import {makeAutoObservable} from "mobx";
import dayjs from "dayjs";
import {DATE_UTIL} from "../common/util/date/date.util";

const logPrefix = "[StatisticsStore]"

export default class StatisticsStore {

    constructor(props) {

        this.userStudyRepository = props.userStudyRepository;

        this.groupId = '';

        this.groupName = '';
        this.studentCount = 0;
        this.studiedStudentCount = 0;
        this.totalStudentCount = 0;
        this.expiredDatetime = null;
        this.remainingDate = 0;
        this.avgCompletionRate = 0;
        this.avgGrade = 0;
        this.avgPronunciationScore = 0;
        this.avgQuizScore = 0;

        this.userStatistics = [];
        this.availableMonths = [];
        this.selectedYear = null;
        this.selectedMonth = null;

        makeAutoObservable(this);

    }

    initStatus = () => {
        this.groupName= '';
        this.avgCompletionRate = 0;
        this.avgQuizScore = 0;
        this.avgGrade = 0;
        this.avgPronunciationScore = 0;
        this.expiredDatetime = null;
        this.studentCount = 0;
        this.studiedStudentCount = 0;
        this.totalStudentCount = 0;
        this.userName = '';
        this.remainingDate = 0;
        this.userStatistics = [];
        this.availableMonths = [];
        this.selectedYear = null;
        this.selectedMonth = null;
    }

    setStatus = (data) => {
        console.log(logPrefix, 'setStatus input summary', data?.summaryStatistic, 'users', data?.userStatistics?.length);
        this.avgCompletionRate = data.summaryStatistic.averageCompletionRate;
        this.avgQuizScore = data.summaryStatistic.averageQuizScore;
        this.avgGrade = data.summaryStatistic.averageGrade;
        this.avgPronunciationScore = data.summaryStatistic.averagePronunciationScore;
        this.selectedYear = data.summaryStatistic.year;
        this.selectedMonth = data.summaryStatistic.month;
        if(data.summaryStatistic.expiredDatetime !== null) {
            this.expiredDatetime = dayjs(data.summaryStatistic.expiredDatetime).format(DATE_UTIL.FORMAT.DATE_FORMAT);
        }else{
            this.expiredDatetime = null;
        }
        this.studentCount = data.summaryStatistic.studentCount;
        this.studiedStudentCount = data.summaryStatistic.studiedStudentCount ?? data.summaryStatistic.studentCount ?? 0;
        this.totalStudentCount = data.summaryStatistic.totalStudentCount ?? data.summaryStatistic.studentCount ?? 0;
        this.groupName = data.summaryStatistic.groupName;
        this.userStatistics = data.userStatistics;

        if (this.selectedYear && this.selectedMonth) {
            console.log(logPrefix, 'apply selected year/month', this.selectedYear, this.selectedMonth);
            const alreadyExists = this.availableMonths.some(month => month.year === this.selectedYear && month.month === this.selectedMonth);
            if (!alreadyExists) {
                this.availableMonths = [
                    {year: this.selectedYear, month: this.selectedMonth},
                    ...this.availableMonths
                ].sort((a, b) => {
                    if (a.year === b.year) {
                        return b.month - a.month;
                    }
                    return b.year - a.year;
                });
            }
        }

        this.setRemainingDate();
    }

    setGroupId = (id) => {
        this.groupId = id;
    }

    setSelectedMonth = (year, month) => {
        this.selectedYear = year;
        this.selectedMonth = month;
        console.log(logPrefix, 'setSelectedMonth', year, month);
    }

    setRemainingDate = () => {
        console.log(logPrefix, 'Start Calculating remaining days');
        console.log(this.expiredDatetime);
        if (this.expiredDatetime !== null) {
            this.remainingDate = Math.ceil((new Date(this.expiredDatetime) - new Date()) / (1000 * 3600 * 24));
        }
        console.log(logPrefix, 'Finishied Calculating remaining days');
    }

    *fetchAvailableMonths(localeGroupId) {
        try {
            console.log(logPrefix, 'Start Get Available Months.', localeGroupId);
            const response = yield this.userStudyRepository.getStatisticMonths(localeGroupId);
            this.availableMonths = response.data || [];
            console.log(logPrefix, 'Available months from API', this.availableMonths);
            if (this.availableMonths.length > 0) {
                this.setSelectedMonth(this.availableMonths[0].year, this.availableMonths[0].month);
                console.log(logPrefix, 'Default select first available', this.selectedYear, this.selectedMonth);
            } else {
                const now = dayjs();
                this.availableMonths = [{year: now.year(), month: now.month() + 1}];
                this.setSelectedMonth(now.year(), now.month() + 1);
                console.log(logPrefix, 'Fallback to current month', this.selectedYear, this.selectedMonth);
            }
            console.log(logPrefix, 'Finished Get Available Months.');
        } catch (e) {
            console.log(logPrefix, 'Failed Get Available Months. error: ' + e);
            const now = dayjs();
            this.availableMonths = [{year: now.year(), month: now.month() + 1}];
            this.setSelectedMonth(now.year(), now.month() + 1);
            console.log(logPrefix, 'Fallback to current month after error', this.selectedYear, this.selectedMonth);
        }
    }

    *getUserStudyStatistics(localeGroupId, year, month, callback) {
        try {
            console.log(logPrefix, 'Start Get User Study Statistic.', localeGroupId, year, month);
            const response = yield this.userStudyRepository.getUserStudyStatistics(localeGroupId, year, month);
            console.log(logPrefix, 'API returned summary', response.data?.summaryStatistic);
            this.setStatus(response.data);
            console.log(logPrefix, 'Finished Get User Study Statistic.');
            callback && callback();
        } catch (e) {
            console.log(logPrefix, 'Failed Get User Study Statistic. error: ' + e);
            if (e.response && e.response.status === 500) {
                this.initStatus();
                console.log(logPrefix, 'Initialize data');
            }
        }
    }

    *recalculateUserStudyStatistics(localeGroupId, year, month, callback) {
        try {
            console.log(logPrefix, 'Start Recalculate User Study Statistic.', localeGroupId, year, month);
            const response = yield this.userStudyRepository.recalculateUserStudyStatistics(localeGroupId, year, month);
            this.setStatus(response.data);
            console.log(logPrefix, 'Finished Recalculate User Study Statistic.');
            callback && callback();
        } catch (e) {
            console.log(logPrefix, 'Failed Recalculate User Study Statistic. error: ' + e);
            callback && callback();
        }
    }

}
